import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import deCommon from './locales/common.de.json';
import deQrGenerator from './locales/qrGenerator.de.json';
import enCommon from './locales/common.en.json';
import enQrGenerator from './locales/qrGenerator.en.json';
import esCommon from './locales/common.es.json';
import esQrGenerator from './locales/qrGenerator.es.json';
import frCommon from './locales/common.fr.json';
import frQrGenerator from './locales/qrGenerator.fr.json';
import itCommon from './locales/common.it.json';
import itQrGenerator from './locales/qrGenerator.it.json';
import jpCommon from './locales/common.jp.json';
import jpQrGenerator from './locales/qrGenerator.jp.json';
import plCommon from './locales/common.pl.json';
import plQrGenerator from './locales/qrGenerator.pl.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            de: {
                common: deCommon,
                qrGenerator: deQrGenerator,
            },
            en: {
                common: enCommon,
                qrGenerator: enQrGenerator,
            },
            es: {
                common: esCommon,
                qrGenerator: esQrGenerator,
            },
            fr: {
                common: frCommon,
                qrGenerator: frQrGenerator,
            },
            it: {
                common: itCommon,
                qrGenerator: itQrGenerator,
            },
            jp: {
                common: jpCommon,
                qrGenerator: jpQrGenerator,
            },
            pl: {
                common: plCommon,
                qrGenerator: plQrGenerator,
            }
        },
        fallbackLng: 'en',
        ns: ['common', 'qrGenerator'],
        defaultNS: 'common',
        detection: {
            order: ['path', 'localStorage', 'navigator'],
            lookupFromPathIndex: 0,
            caches: ['localStorage'],
        },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
